
































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import type { ProjectUser } from '@/models/projectUser';
import type { Trade } from '@/models/trade';
import type { Phase } from '@/models/phase';

@Component({
    name: 'TradesToDosFilters',
    components: {},
})
export default class TradesToDosFilters extends Vue {
    private selectedResponsibleUsers: ProjectUser[] = [];
    private selectedTrades: Trade[] = [];
    private selectedPhase: Phase | null = null;

    @Getter('project/selectedProject') private selectedProject: Project;
    @Prop() private isDesktop: boolean;
    @Prop() private errors: string[];

    @Watch('selectedProject')
    private onSelectedProjectChange() {
        this.selectedTrades = this.selectedProject.trades;
        // We need to emit this event manually to store the value in TradeToDosList
        this.$emit('update:selected-trades', this.selectedTrades);

        this.selectedResponsibleUsers = this.allProjectUsers;
        this.$emit('update:selected-responsible-users', this.selectedResponsibleUsers);

        if (this.selectedProject.phases.length > 0) {
            this.selectedPhase = this.selectedProject.phases[0];
            this.$emit('update:selected-phase', this.selectedPhase);
        }
    }

    private checkError(errorKey: string) {
        return this.errors.includes(errorKey);
    }

    private fullname({ firstname, lastname }) {
        return `${firstname} ${lastname}`;
    }

    private get allProjectUsers() {
        const projectUsers: ProjectUser[] = [];
        this.selectedProject.users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: false,
            };
            projectUsers.push(temp);
        });
        this.selectedProject.external_users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: true,
            };
            projectUsers.push(temp);
        });

        return projectUsers;
    }
}
